 
import each from 'lodash/each'
import map from 'lodash/map'
// App Store
import { app } from './utils/store'

// User Detect
import { DetectionManager } from './utils/detect'

// Navigation
import { Navigation, Footer } from './modules/Navigation'
import { BottomBar } from './modules/BottomBar'
import Menu from './modules/Menu'


// Classes::Managers
// import { CursorManager } from "./modules/Cursor"
import { AccordionManager } from './classes/Accordions'
import { DropdownManager } from './classes/Dropdowns'
import { TabManager } from './classes/Tabs'
import { TogglerManager } from './classes/Togglers'
import { ModalManager } from './classes/Modal'
// import { ScrollManager } from './classes/Scroll'

// AsyncLoad
import AsyncLoad from './classes/AsyncLoad'

// Module
import Preloader from './modules/Preload'
class App {
    constructor() {
        app.init = true
        app.bundle = false
        app.root = document.body
        app.viewport = document.querySelector('[data-app-viewport]')
        app.content = document.getElementById("app-content")

        //Async Load
        app.images = document.querySelectorAll('[data-src][data-webp]')
        // console.log(this.images, this.preloaders)

        // Cursor::Only if is Desktop
        // if (app.device.desktop) {
        //     CursorManager.create()
        // }

        app.create = {
            preloaders: this.createPreloaders.bind(this),
            content: this.createContent.bind(this),
            // scroll: this.createScroll.bind(this),
            navigation: this.createNavigation.bind(this),
            accordions: this.createAccordions.bind(this),
            dropdowns: this.createDropdowns.bind(this),
            togglers: this.createTogglers.bind(this),
            modals: this.createModals.bind(this),
        }

        map(app.create, (callback) => { return callback() })

        // console.log(app)
    }

    // Create Content
    createContent = () => {
        this.template = app.root.getAttribute('data-template')
        this.content = document.querySelector('[data-app-content]')

        this.wrapper = document.querySelector('[data-wrapper]')

        // this.menu = document.querySelectorAll('[data-navigation-menu]')

        this.anchors = document.querySelectorAll('a[href^="#"]:not([href="#"])')

        this.accordion = { togglers: document.querySelectorAll('.accordion-button'), }
        this.dropdown = { togglers: document.querySelectorAll('[data-bs-toggle="dropdown"]'), }
        this.tabs = { togglers: document.querySelectorAll('button[role="tab"]'), }
        this.click = { togglers: document.querySelectorAll('[data-click-target]'), }
        this.modal = {
            elements: document.querySelectorAll('[data-modal]'),
            togglers: document.querySelectorAll('[data-modal-target]'),
            closers: document.querySelectorAll('[data-modal-close]')
        }

        // this.statusbar = document.querySelector('[data-navigation-bottom-bar]')
        this.forms = document.querySelectorAll('form')
        this.search = document.getElementById('global-search')

        this.carousels = document.querySelectorAll('[data-carousel]')
        this.finishes = document.querySelectorAll('ul.list--materials')

        app.current = this.template
        app.wrapper = this.wrapper

        // app.scroll = window
    }

    // Create Navigation
    createNavigation = () => {
        this.statusbar = document.querySelector('[data-navigation-bottom-bar]')
        this.menu = document.querySelectorAll('[data-navigation-menu]')

        this.navigation = new Navigation({ init: app.bundle })
        this.footer = new Footer({ init: app.bundle })
        if (this.statusbar) { this.statusbar = new BottomBar({ init: app.bundle }) }

        if (this.menu) { each(this.menu, (entry, index) => new Menu({ element: entry })) }
    }

    // Create Preloaders
    createPreloaders = () => {
        app.preloader = new Preloader()
        app.preloader.once('completed', this.onPreloaded.bind(this))
    }

    // Create Accordions
    createAccordions = () => {
        each(this.accordion.togglers, (accordion) => AccordionManager.create(accordion))
    }

    // Create Dropdowns
    createDropdowns = () => {
        each(this.dropdown.togglers, (dropdown) => DropdownManager.create(dropdown))
    }

    // Create Tabs
    createTabs = () => {
        each(this.tabs.togglers, (tab) => TabManager.create(tab))
    }

    // Create Togglers
    createTogglers = () => {
        each(this.click.togglers, (toggler) => TogglerManager.toggle(toggler))
    }

    // Create Modals
    createModals = () => {
        each(this.modal.togglers, (toggler) => ModalManager.toggle(toggler))
        each(this.modal.closers, (closer) => ModalManager.close(closer))
    }

    // Create Scroll
    // createScroll = () => {
    //     ScrollManager.onLoadAnchor()

    //     if (this.anchors) {
    //         this.anchors.forEach((link) => ScrollManager.scrollBehaviour(link))
    //     }
    // }

    /*
    ** Events
    */

    // On Loaded
    onPreloaded() {
        app.loading = false
        app.html.classList.remove('loading')
        app.html.classList.remove('scroll--off')

        this.preloaders = each(app.images, image => {
            return new AsyncLoad({ element: image })
        })

        // Display Contents (Critical Visuals)
        if (app.nav) {
            each(app.nav.querySelectorAll('[data-navigation-menu]'), (menu) => { menu.style.removeProperty('visibility') })

            if(app.nav.querySelector('[data-main-actions]')){
                app.nav.querySelector('[data-main-actions]').style.setProperty('visibility', 'visible')
            }
        }
        if (this.modal.elements) { each(this.modal.elements, (modal) => { modal.style.removeProperty('visibility') }) }

        if (app.init && app.preloader) { app.preloader.destroy() }
    }

}

new App()